import { capitalize } from 'lodash'
import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { ListItem } from '../AbstractList/ListItem'

const posters = [
  {
    id: 1,
    title: 'IMPACT OF POLYGAMOUS MARRIAGE ON WOMEN AND CHILDREN: A SYSTEMATIC REVIEW AND META-ANALYSIS',
    presenting_author_name: 'Mohamad Shahirul Aiman Che Abd Aziz, Shaiful Bahari Ismail, Norhayati Mohd Noor, Nik Muhammad Arif Nik Amad, Nik Hazlina Nik Hussain',
  },
  {
    id: 2,
    title: 'CERVICAL DILATOR FOR BLOCKAGE DURING EMBRYO TO TRANSER',
    presenting_author_name: 'Dr. P.D. Krihna Kumar',
  },
  {
    id: 3,
    title:
      'BONE HEALTH STATUS AMONG "AT RISK" ADOLESCENTS AND YOUNG WOMEN IN PAG CLINIC: ASSESSMENT OF PREVALENCE & TREATMENT EFFECTS',
    presenting_author_name: 'Anizah A, Zahra Amani MK, Nur Azurah AG, Ani Amelia Z',
  },
  {
    id: 4,
    title: 'A RARE CASE OF ADENOMATOID TUMOR: A CASE REPORT',
    presenting_author_name: 'Michelle Ong Ying Ying, Aisyah binti AL, Lee Chui Ling',
  },
  {
    id: 5,
    title: 'ENDOMETRIAL CANCER IN PRE-MENOPAUSAL WOMEN AND YOUNGER: RISK FACTORS AND OUTCOME',
    presenting_author_name: 'Nurliza Abdol Manap, Ng Beng Kwang, Rosnah Binti Ismail, Dr Maimunah Fadhil',
  },
  {
    id: 6,
    title: 'LAPAROSCOPIC TRANSIENT OVARIOPEXY FOR ENDOMETRIOMA AND FERTILITY OUTCOMES A CASE SERIES',
    presenting_author_name: 'Sevellaraja Supermaniam, Wei Lin Thye',
  },
  {
    id: 7,
    title: 'A STUDY ON PREVALENCE OF MENOPAUSE SYMPTOMS AND QUALITY OF LIFE AMONG POST-MENOPAUSAL WOMEN IN SHAH ALAM, MALAYSIA',
    presenting_author_name: 'Myo Hla Myint, Tuty Fathiah Binti Fuad Salim, Soe Moe, Thavamani Manoharan, Najimudeen M, Masharudin Abdul Wahab',
  },
  {
    id: 8,
    title: 'PREVALENCE OF PSYCHOMATIC AND GENITOURINARY SYNDROME AMONG MENOPAUSAL WOMEN: A SYSTEMATIC REVIEW AND META-ANALYSIS',
    presenting_author_name: 'Nik Muhammad Arif Nik Ahamd, Nik Hazlina Nik Hussain, Norhayati Mohd Noor, Shaiful Bahari Ismail',
  },
  {
    id: 9,
    title: 'BONE MINERAL DENSITY STATUS IN PATIENTS WITH TURNER SYNDROME ATTENDING THE PAEDIATRICS AND ADOLESCENT GYNAECOLOGY (PAG) UNIT, HOSPITAL CANSELOR TUANKU MUHRIZ (HCTM), UKM: 5 YEAR REVIEW',
    presenting_author_name: 'Nurkhairulnisa Abu Ishak, Nur Azurah Abdul Ghani, Anizah Ali, Ani Amelia Zainuddin',
  },
  {
    id: 10,
    title: 'CHRONIC NON PUERPERAL UTERINE INVERSION (NPUI)',
    presenting_author_name: 'Mohd Amin Bin Ismail, MD, Mahabbatamini Bin Muhamad, MD, Nor Azlina Binti Che Yaacob, MD, Alifah Binti Mohd Zizi, MD, Enie Akhtar Binti Nawawi, MD',
  },
  {
    id: 11,
    title: 'PROBIOTIC EFFECTS IN PRIMARY DYSMENORRHOEA',
    presenting_author_name: 'IA Zakaria, NA Mohd Zain, KT Chew, MA Abu, AA Zainuddin, NH Abdul Aziz, N Safian, N Mohd Mokhtar, RA Raja Ali, NA Abdul Ghani',
  },
  {
    id: 12,
    title: 'THE EFFECTS OF 12-MONTHS SUPPLEMENTATION OF TUALANG HONEY VERSUS HONEY COCKTAIL ON HARMONAL PROFILES AND PSYCHOSEXUAL CHANGES AMONG POSTMENOPAUSAL WOMEN',
    presenting_author_name: 'Siti Zubaidah Ab Wahab, Nik Hazlina Nik Hussain, Rahimah Zakaria, Norazlina Mohamed, Noorlaili Tohit, Azidah Abdul Kadir, Norhayati Mohd Noor, Intan Idiana Hassan',
  },
  {
    id: 13,
    title: 'SIMPLE CYSTECTOMY OR UNILATERAL SALPINGO-OOPHRECTOMY FOR MUCINOUS CYSTADENOMA IN A YOUNG GIRL?',
    presenting_author_name: 'Tan SY, Nurul Huda R, Lee CL, Ghazali I',
  },
]

export const Eposter: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('E-Gallery'))
    dispatch(setPreviousPage(routes.lobby))
  }, [dispatch])

  return (
    <div className="normal-container">
      {posters.map((poster) => {
        return <ListItem key={poster.id} abstractType="poster" title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
      })}
    </div>
  )
}
